<template>
    <span
    style="
        left: 78px;
        top: 1px;
        color: var(--el-input-text-color, var(--el-text-color-regular));
    ">
        <i class="fa fa-caret-up"></i>
    </span>
</template>
